import { useState } from 'react';
import { tapLight } from '../lib/haptics';

const SEEN_KEY = 'coach-swipe-seen';

/**
 * First-run coach mark for the swipe gesture: a small card with an animated
 * demo tile sliding right, shown above the dashboard's first chore list until
 * dismissed. Shows once per device (localStorage).
 */
export function SwipeCoachMark() {
  const [seen, setSeen] = useState(() => localStorage.getItem(SEEN_KEY) === 'true');
  if (seen) return null;

  const dismiss = () => {
    tapLight();
    localStorage.setItem(SEEN_KEY, 'true');
    setSeen(true);
  };

  return (
    <div className="coach-mark" role="note">
      <div className="coach-mark-demo" aria-hidden="true">
        <span className="coach-mark-action"><ion-icon name="checkmark-circle" /></span>
        <span className="coach-mark-tile">
          <ion-icon name="hand-left-outline" className="coach-mark-hand" />
        </span>
      </div>
      <div className="coach-mark-text">
        <span className="coach-mark-title">Swipe to finish</span>
        <span className="coach-mark-sub">Swipe a chore right to complete it — left to skip.</span>
      </div>
      <button className="btn btn-sm btn-primary coach-mark-dismiss" onClick={dismiss}>
        Got it
      </button>
    </div>
  );
}
